export const serviciosCaptacion = {
  background: "linear-gradient(135deg, #faf3fb, #f1e7f4)",

  servicios: [
    {
      id: "captacion",
      nombre: "CAPTACIÓN",
      precio: "Desde $280.000",
      descripcion:
        "Creamos un circuito digital para atraer personas, generar interés y convertir consultas en contactos.",

      color: "#891594",

      badge: "SERVICIO INICIAL",

      boton: "QUIERO CAPTAR CLIENTES",

      items: [
        "Contenido para atraer",
        "Configuración de publicidad",
        "Formulario de consultas",
        "Integración con WhatsApp",
        "Landing profesional",
        "Configuración inicial",
        "Registro de consultas",
        "Circuito completo de captación",
      ],

      etapas: [
        {
          titulo: "ATRAER",
          descripcion: "Contenido",
        },
        {
          titulo: "INTERESAR",
          descripcion: "Publicidad",
        },
        {
          titulo: "CAPTAR",
          descripcion: "Formulario",
        },
        {
          titulo: "CONTACTAR",
          descripcion: "WhatsApp",
        },
      ],
    },

    {
      id: "gestion",
      nombre: "GESTIÓN + MÉTRICAS",
      precio: "Desde $450.000",
      descripcion:
        "Convertimos las consultas en información útil para conocer qué funciona y mejorar el proceso comercial.",

      color: "#5d2470",

      destacado: true,

      badge: "SISTEMA COMPLETO",

      boton: "QUIERO MEDIR",

      items: [
        "Todo lo incluido en CAPTACIÓN",
        "Dashboard privado",
        "Registro de consultas",
        "Estados de cada consulta",
        "Métricas de captación",
        "Seguimiento de contactos",
        "Estadísticas por período",
        "Consultas por canal",
        "Integración con Bases de Datos",
        "Mejoras y optimización del sistema",
      ],

      etapas: [
        {
          titulo: "ATRAER",
          descripcion: "Contenido",
        },
        {
          titulo: "INTERESAR",
          descripcion: "Publicidad",
        },
        {
          titulo: "CAPTAR",
          descripcion: "Formulario",
        },
        {
          titulo: "CONTACTAR",
          descripcion: "WhatsApp",
        },
        {
          titulo: "MEDIR",
          descripcion: "Dashboard",
        },
      ],
    },
  ],
};